import { EntityType } from './person'

export enum DocumentStatusEnum {
  rejected = 'Rejeitado',
  approved = 'Aprovado',
}

export type DocumentStatus = keyof typeof DocumentStatusEnum

export enum DocumentRequestStatusEnum {
  pending = 'Pendente',
  pending_review = 'Revisão',
  approved = 'Aprovado',
}

export type DocumentRequestStatus = keyof typeof DocumentRequestStatusEnum

export type DocumentRequest = {
  created_at: string
  updated_at: string
  id: number
  key: string
  account_key?: string
  entity_id: number
  entity_type: EntityType
  type: 'monthly_financial_movement'
  status: DocumentRequestStatus
  month: string
  year: string
  documents: Document[]
  observation?: string
}

export const DocumentTypeEnum = {
  iptu: 'IPTU',
  address: 'Comprovante de endereço',
  personal: 'Documento de identificação com foto (frente e verso)',
  proof_of_income: 'Comprovante de renda',
  payslip: 'Holerite',
  income_tax_return: 'Demonstrativo de rendimentos',
  bank_statement: 'Extrato bancário',
  bank_statement_pdf: 'Extrato bancário PDF',
  bank_investment_statement: 'Extrato de investimentos',
  other: 'Outro',
  company_social_contract: 'Contrato social original ou última alteração',
  professional_council_membership_card:
    'Carteira do Conselho Regional de Classe',
} as const

export type DocumentType = keyof typeof DocumentTypeEnum

export type DocumentUploadPayload = {
  entity_key: string
  entity_type: EntityType
  document_type: DocumentType
  document_request_key?: string
  observation?: string
}

export type Document = {
  key: string
  original_name: string
  type: DocumentType
  mime_type?: string
  size?: number
  url?: string
  reject_reason?: string | null
  status?: DocumentStatus | null
}
